import * as React from "react";
import { StyledHeader, CoverWrapper } from "components/Releases/styles";
import { Release } from "types/release";
import { ReleaseCode } from "components/Releases/ReleaseCode";
import { CreateReleaseDate } from "components/Releases/CreateReleaseDate";
import { GenreInfo } from "components/Releases/GenreInfo";
import { ReleaseArtists } from "components/Releases/ReleaseArtists";
import { Cover } from "components/Releases/Cover";
import { Platforms } from "components/Releases/Platforms";
import { Status } from "components/Releases/Status";
import {FormattedMessage} from "react-intl";

export const getColumns = () => [
  {
    body: (data: Release) => {
      return (
        <CoverWrapper>
          <Cover cover={data.cover_url} height="75px" width="75px" />
          <Status status={data.status} isMinimalistic={true} />
        </CoverWrapper>
      )
    },
    field: 'cover_url',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.CoverArt"
          defaultMessage="Cover art"
        />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      return <ReleaseArtists artists={data.artists} release={data.title} />;
    },
    columnKey: 'artists',
    field: 'artists',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.ReleaseArtist"
          defaultMessage="Release/Artist"
        />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      return <GenreInfo genres={data.genres} />;
    },
    columnKey: 'genre',
    field: 'genre',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.Genre"
          defaultMessage="Genre"
        />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      return <CreateReleaseDate createdAt={data.created_at} releaseDate={data.release_date} />;
    },
    columnKey: 'created_at',
    field: 'created_at',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.CreateReleaseDate"
          defaultMessage="Create date/Release date"
        />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      return <ReleaseCode id={data.id} ean={data.ean} />;
    },
    columnKey: 'ean',
    field: 'ean',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.ReleaseCode"
          defaultMessage="Release code"
        />
      </StyledHeader>
    )
  },
  {
    body: (data: Release) => {
      return <Platforms platforms={data.platforms} />;
    },
    columnKey: 'platforms',
    field: 'platforms',
    header: (
      <StyledHeader>
        <FormattedMessage
          id="Releases.Columns.DeliveredPlatforms"
          defaultMessage="Delivered platforms"
        />
      </StyledHeader>
    )
  }
];
